
export enum AccountingPeriodType {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}
